import FlexPane from 'presentation/components/flex-pane/index.js';
import SportIcon from 'presentation/components/sport-icon/index.js';
import CountryIcon from 'presentation/components/country-icon/index.js';

const SportAndCountryIcon = props => {
    const { sportId, countryCode, countryName, alt, mojitoTools } = props;
    const { config } = mojitoTools;
    const showSportIcon = config.showSportIcon;
    const showCountryIcon = config.showCountryIcon && !!countryCode;

    if (!showSportIcon && !showCountryIcon) {
        return null;
    }

    return (
        <FlexPane class="ta-SportAndCountryIcon" config={config.container}>
            {showSportIcon && <SportIcon sportId={sportId} config={config.sportIcon} alt={alt} />}
            {showCountryIcon && (
                <CountryIcon
                    countryCode={countryCode}
                    countryName={countryName}
                    config={config.countryIcon}
                />
            )}
        </FlexPane>
    );
};

export default SportAndCountryIcon;
